import axios from "axios";

export default {
  methods: {
    mediaDataUrl(config) {
      const mediaPathFixed = config.url.replace("https://", "").split("/");
      const first = mediaPathFixed.shift();

      let bucket = "dpov-production";

      if (config.url.includes("staging")) {
        bucket = "dpov-staging";
      }

      if (config.url.includes("testing")) {
        bucket = "dpov-testing";
      }

      const imageUrl = JSON.stringify({
        bucket,
        key: `${first.split(".")[0]}/${mediaPathFixed.join("/")}`,
        edits: config.edits,
      });
      return `https://media.cenora.io/${btoa(imageUrl)}`;
    },
    async getImageFromMediaManager(
      mediaManagerRequestUrl,
      cid,
      mediaTags,
      section,
      imageSize,
      optionalTags
    ) {
      try {
        let type = "landscape";

        if (imageSize) {
          type = imageSize;
        }

        const { data } = await axios.get(mediaManagerRequestUrl, {
          params: {
            cid,
            tags: mediaTags ? mediaTags.join(",") : undefined,
            otherTags: optionalTags ? optionalTags.join(",") : undefined,
            categories: [section].join(","),
            type,
          },
          timeout: 2000,
        });

        return data[0];
      } catch (error) {
        if (error.response.data instanceof Array) {
          return error.response.data[0];
        }

        throw error;
      }
    },
    async getImgUrl({
      url,
      type,
      mediaTags,
      section,
      cid,
      mediaManagerRequestUrl,
      imageSize,
      original,
      optionalTags,
      poster = null,
      imageHandlerConfig = {},
    }) {
      if ((mediaTags || optionalTags) && mediaManagerRequestUrl) {
        let returnData;

        try {
          returnData = await this.getImageFromMediaManager(
            mediaManagerRequestUrl,
            cid,
            mediaTags,
            section,
            imageSize,
            optionalTags
          );

          if (returnData) {
            return returnData;
          }
        } catch (error) {}
      }

      if (
        !url.includes("cenora.io") ||
        url.includes("media.cenora.io") ||
        original
      ) {
        return url;
      }

      const isSafari = /^((?!chrome|android).)*safari/i.test(
        navigator.userAgent
      );
      const canShowWebp =
        !isSafari ||
        (isSafari &&
          Number(
            navigator.userAgent
              .split(" ")
              .find((a) => a.includes("Version"))
              .split("/")[1]
          ) >= 14);

      switch (type) {
        case "image":
          return this.mediaDataUrl({
            url,
            edits: {
              toFormat: !canShowWebp ? "jpg" : "webp",
              ...imageHandlerConfig,
            },
          });
        case "video":
          if (isSafari) {
            return poster;
          }

          return url.replace(".mp4", ".webp");
      }
    },
    async onError(ev, cid, section, options = { returnValue: false }) {
      let env = ".testing";

      if (process.env.ENV === "staging") {
        env = ".staging";
      }

      if (process.env.ENV === "production") {
        env = "";
      }

      let src = await this.getImgUrl({
        url: `https://assets${env}.cenora.io/${cid}/images/no-image${
          section ? `-${section}` : ""
        }.jpg`,
        type: "image",
      });

      try {
        await axios.get(src);
      } catch (error) {
        src = await this.getImgUrl({
          url: `https://assets${env}.cenora.io/${cid}/images/no-image.jpg`,
          type: "image",
        });
      }

      if (options.returnValue) {
        return src;
      }

      if (ev.target.src === src) {
        return;
      }

      ev.target.src = src;
    },
  },
};
